"use strict";

module.exports = function (object) {
  return object ? Object.keys(object) : [];
};


//////////////////
// WEBPACK FOOTER
// ./~/fun-util/lib/utils/getKeys.js
// module id = 336
// module chunks = 37